import { useLanguage } from "@/contexts/LanguageContext";
import arcImage from "@/assets/arc.png";

const PainSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="pain" className="pt-20 md:pt-48 pb-16 md:pb-24 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0 grid-pattern opacity-20" />
      
      <div className="container mx-auto max-w-7xl relative z-10">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-12 md:mb-16 text-center text-glow-hover uppercase">
          {t("pain.titleStart")} <span className="text-holographic">{t("pain.titleHighlight")}</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-12 md:mb-20">
          <div className="space-y-4 md:space-y-6">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">
              {t("pain.fragmented")}
            </h3>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              {t("pain.description")}
            </p>
          </div>

          <div className="flex justify-center">
            <img src={arcImage} alt="Holographic 3D Arc" className="w-full max-w-sm animate-spin-glow" />
          </div>
        </div>

        <div className="relative">
          <div className="glass-card rounded-2xl p-8 md:p-12 glow-on-hover">
            <div className="text-center mb-6 md:mb-8">
              <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-2">
                <span className="text-holographic">Shape</span> <span className="text-white">{t("pain.shapeBrings")}</span> –
              </h3>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 max-w-4xl mx-auto">
              <div className="glass-card rounded-xl p-6 text-center glow-on-hover hover-slide-up min-h-[100px] flex flex-col justify-center">
                <div className="text-4xl md:text-5xl lg:text-6xl font-black text-outline-white mb-2 md:mb-3">1</div>
                <p className="text-lg md:text-xl lg:text-2xl font-semibold hover-glow-text">{t("pain.team")}</p>
              </div>

              <div className="glass-card rounded-xl p-6 text-center glow-on-hover hover-slide-up min-h-[100px] flex flex-col justify-center">
                <div className="text-4xl md:text-5xl lg:text-6xl font-black text-outline-white mb-2 md:mb-3">1</div>
                <p className="text-lg md:text-xl lg:text-2xl font-semibold hover-glow-text">{t("pain.direction")}</p>
              </div>

              <div className="glass-card rounded-xl p-6 text-center glow-on-hover hover-slide-up min-h-[100px] flex flex-col justify-center">
                <div className="text-4xl md:text-5xl lg:text-6xl font-black text-outline-white mb-2 md:mb-3">1</div>
                <p className="text-lg md:text-xl lg:text-2xl font-semibold hover-glow-text">{t("pain.result")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainSection;